import { useEffect, useState } from "react";
import ReactGA from "react-ga4";
import { isAndroid, isIOS } from "react-device-detect";
import { detectInAppBrowser } from "../Helpers/inAppBrowserDetection";

const buildChromeIntentUrl = () => {
  const { href, protocol } = window.location;
  const withoutScheme = href.replace(`${protocol}//`, "");
  const fallback = encodeURIComponent(href);
  return `intent://${withoutScheme}#Intent;scheme=https;package=com.android.chrome;S.browser_fallback_url=${fallback};end;`;
};

const useInAppBrowserEscape = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const { isInApp, app } = detectInAppBrowser();
    if (!isInApp) return;

    ReactGA.event({
      category: "InAppBrowser",
      action: "Detected",
      label: `${app || "unknown"} | ${navigator.userAgent}`,
    });

    if (isAndroid) {
      window.location.href = buildChromeIntentUrl();
      return;
    }

    if (isIOS) {
      setShowBanner(true);
    }
  }, []);

  return { showBanner };
};

export default useInAppBrowserEscape;
